var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"button",staticClass:"text-bigger"},[_c('router-link',{class:_vm.isDark? 'text-white' : 'text-muted',attrs:{"to":{name: 'about'}}},[_c('i',{staticClass:"far fa-question-circle"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }